<template>
  <div class="header d-flex justify-center items-center p-fixed">
    <img :src="ICON_LOGO" alt="JAサイネージロゴ" class="header-logo" />
    <button class="popover-area" @click="showPopover">
      <div class="user-name">
        {{ userName }}
      </div>
      <div class="menu">
        <v-ons-icon class="menu-icon" icon="fa-caret-down" size="25px" />
        <v-ons-popover
          animation="none"
          class="menu-popover"
          cancelable
          v-model:visible="popoverVisible"
          :target="'.menu-icon'"
          direction="down"
        >
          <v-ons-list modifier="noborder">
            <Button
              class="menu-item"
              tappable
              @click="moveMonitorManagement()"
              modifier="longdivider"
            >
              登録済みモニター管理
            </Button>
            <Button class="menu-item" tappable @click="requestPermission()" modifier="longdivider">
              通知を許可
            </Button>
            <Button class="menu-item" tappable @click="clickLogoutDialog" modifier="nodivider">
              ログアウト
            </Button>
          </v-ons-list>
        </v-ons-popover>
      </div>
    </button>
    <div v-show="isRequestPermissionWait" class="progress-circular-wrapper">
      <progress-circular />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ProgressCircular from '@/components/common/ProgressCircular.vue';
import { getMessaging, getToken } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import axios from '@/composable/axios';
import { FIREBASE_CONFIG, VAP_ID } from '@/composable/constant';
import Button from '@/components/common/Button.vue';
import { onsConfirm } from '@/composable/onsen_common';
import { ICON_LOGO } from '@/composable/constant_common';

// Props
defineProps({
  userName: String,
});

// Data (refで宣言)
const popoverVisible = ref(false);
const isRequestPermissionWait = ref(false);
const message = ref('');
const token = ref('');

// Vue RouterとVuexのインスタンス
const router = useRouter();
const store = useStore();

// Methods
const postToken = () => {
  if (token.value) {
    const NotificationParameters = new FormData();
    NotificationParameters.append('token', token.value);

    console.log('NotificationParameters:', NotificationParameters.get('token'));

    axios
      .post('/notification', NotificationParameters, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        console.log('post成功:', res);
      })
      .catch((error) => {
        console.error('通知トークンの登録に失敗しました:', error);
      });
  } else {
    console.log('登録トークンがありません。生成する許可をリクエストします。');
  }
};

const logout = () => {
  // セッショントークンを削除
  localStorage.removeItem('token');
  // vuex データキャッシュを削除
  localStorage.removeItem('jasignage');
  store.commit('userInformation/setUserId', '');
  store.commit('userInformation/setUserName', '');
  router.push('/ja/login');
};

const showPopover = () => {
  popoverVisible.value = true;
};

const hidePopover = () => {
  popoverVisible.value = false;
};

const clickLogoutDialog = async () => {
  hidePopover();

  try {
    await onsConfirm('ログアウトしますか？');
    logout();
  } catch {
    // 処理なし
  }
};

const moveMonitorManagement = () => {
  hidePopover();
  router.push('/ja/MonitorManagement');
};

const requestPermission = async () => {
  initializeApp(FIREBASE_CONFIG);

  if (!('Notification' in window)) {
    alert('このブラウザーはデスクトップ通知には対応していません。');
    return;
  }

  if (Notification.permission !== 'denied') {
    Notification.requestPermission().then(async (permission) => {
      if (permission === 'granted') {
        isRequestPermissionWait.value = true;

        try {
          message.value = getMessaging();

          if ('serviceWorker' in navigator) {
            await navigator.serviceWorker.register('/firebase-messaging-sw.js');
            const swRegistration = await navigator.serviceWorker.ready;

            token.value = await getToken(message.value, {
              vapidKey: VAP_ID,
              serviceWorkerRegistration: swRegistration,
            });

            postToken();
            alert('通知を許可しました。');
            isRequestPermissionWait.value = false;
          }
        } catch (error) {
          alert('通知の許可に失敗しました。再度、「通知を許可」ボタンを押してください。');
        }
      } else if (permission === 'denied') {
        alert('通知をブロックしました。');
      } else {
        console.log('通知のリクエストが無視されました');
      }
    });
  }

  hidePopover();
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 5vh;
  height: 5dvh;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  background-color: white;
}
.header-logo {
  width: 100%;
  height: 3rem;
  object-fit: contain;
  object-position: left;
  margin-left: 30px;
  margin-top: 15px;
}
.user-name {
  width: 50%;
  font-size: 1.3rem;
  color: #222222;
  text-align: right;
  margin-top: 15px;
}
.menu {
  width: 5%;
  margin: 15px 30px 5px 5px;
}
.menu-item {
  font-size: 1.3rem;
  color: black;
  background-color: white;
  width: 100%;
  text-align: left;
  border-bottom: 1px #cbcbcb solid;
  padding: 5px 14px;
}
.menu-item:last-child {
  border: none;
}
.menu-icon {
  color: #aaaaaa;
}
.menu-popover :deep(.popover-mask) {
  position: fixed;
}
.menu-popover :deep(.popover__content) {
  min-height: 100%;
  width: 16rem;
}
.popover-area {
  width: 50%;
  display: contents;
}
.progress-circular-wrapper {
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2;
}
</style>
